// Shared package catalogue — Basic vs Advanced Precision Liver Evaluation.
export const PACKAGES = {
  basic: {
    key: "basic",
    name: "Basic",
    fullName: "Basic Precision Liver Evaluation",
    price: 499900,
    biomarkers: "73+",
    risk: "Yellow",
    riskHex: "#EAB308",
    riskText: "#713F12",
  },
  advanced: {
    key: "advanced",
    name: "Advance",
    fullName: "Advance Precision Liver Evaluation",
    price: 799900,
    biomarkers: "100+",
    risk: "Orange",
    riskHex: "#F97316",
    riskText: "#FFFFFF",
  },
  consultation: {
    key: "consultation",
    name: "Consultation",
    fullName: "Online Liver Consultation",
    price: 250000,
  },
};

export const inr = (paise) => `₹${(paise / 100).toLocaleString("en-IN")}`;
